module.exports = __webpack_public_path__ + "img/Allen.6bc626bc.png";